// extracted by mini-css-extract-plugin
export default {"ContentContainer":"ContentContainer_ContentContainer__ZIX-1"};